import React from 'react'
import {AiFillFacebook,AiFillTwitterCircle,AiFillInstagram,AiFillYoutube} from 'react-icons/ai'

const Footer = () => {
    return (
        <>
            <div className="footer_main">
                <div className="footer_social_media">
                    <AiFillFacebook style={{color:"white"}}  className='footer_social'/>
                    <AiFillInstagram style={{color:"white"}}  className='footer_social'/>
                    <AiFillTwitterCircle style={{color:"white"}} className='footer_social' />
                    <AiFillYoutube style={{color:"white"} } className='footer_social'/>
                </div>
                <div className="footer_links">
                    <ul className='footer_ul'>
                        <li className='link_item'><a href="#" className='link_item'>Site Index</a></li>
                        <li className='link_item'><a href="#" className='link_item'>IMDb Pro</a></li>
                        <li className='link_item'><a href="#" className='link_item'>Box Office Pro</a></li>
                        <li className='link_item'><a href="#" className='link_item'>Privacy Policy</a></li>
                    </ul>
                </div>
            </div>  
        </>
    )
}

export default Footer
